import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { isEmpty } from 'lodash';
import dompurify from 'dompurify';

import { generateString } from '@nile/components';
import { dompurifier } from '@nile/components/src/Utils/helpers';

const RTEPreview = styled.div`
  /* The Modal (background) */
  .modal {
    display: none; /* Hidden by default */
    position: fixed; /* Stay in place */
    z-index: 10; /* Sit on top */
    // padding-top: 100px; /* Location of the box */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0, 0, 0); /* Fallback color */
    background-color: rgba(0, 0, 0, 0.9); /* Black w/ opacity */
  }

  /* Modal Content (image) */
  .modal-content {
    margin: auto;
    display: block;
    // width: 100%;
    max-width: 90vw;
  }

  @-webkit-keyframes zoom {
    from {
      -webkit-transform: scale(0);
    }
    to {
      -webkit-transform: scale(1);
    }
  }

  @keyframes zoom {
    from {
      transform: scale(0);
    }
    to {
      transform: scale(1);
    }
  }

  /* The Close Button */
  .close {
    position: absolute;
    top: 15px;
    right: 35px;
    color: #f1f1f1;
    font-size: 40px;
    font-weight: bold;
    transition: 0.3s;
  }

  .close:hover,
  .close:focus {
    color: #bbb;
    text-decoration: none;
    cursor: pointer;
  }

  /* 100% Image Width on Smaller Screens */
  @media only screen and (max-width: 700px) {
    .modal-content {
      width: 100%;
    }
  }
  img {
    max-width: 100%;
  }
`;

function RichTextEditorPreview({ value }) {
  const [randomId] = useState(generateString(5) || '110011');

  const handleEscPress = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (e?.keyCode === 27 || e?.which === 27 || e?.key === 'Escape') {
      if (
        window.getComputedStyle(document.querySelector(`.modal-${randomId}`))
          .display === 'flex'
      ) {
        document.querySelector(`.modal-${randomId}`).style.display = 'none';
      }
      window.removeEventListener('keyup', handleEscPress);
    }
  };

  const handleOnImageClick = (e) => {
    const modal = document.querySelector(`.modal-${randomId}`);

    const modalImg = document.querySelector(`.modal-content-${randomId}`);

    modal.style.display = 'flex';
    modalImg.src = e.target.currentSrc;
    window.addEventListener('keyup', handleEscPress);
  };

  useEffect(() => {
    if (
      document?.querySelector(`.${randomId}`)?.querySelectorAll('img')?.length
    ) {
      document
        ?.querySelector(`.${randomId}`)
        ?.querySelectorAll('img')
        ?.forEach((img) => {
          img.classList.add('hover-hand', 'mw100');
          img.onclick = handleOnImageClick;
        });
    }
  }, [value]);

  return (
    <RTEPreview className="mt4 position-relative">
      <div
        className={`message-content ${randomId}`}
        dangerouslySetInnerHTML={{
          __html: isEmpty(value) ? dompurifier('<p>NA</p>') : dompurifier(value)
        }}
      />

      <div id={`myModal`} className={`modal modal-${randomId}`}>
        <span
          className="close"
          onClick={() => {
            document.querySelector(`.modal-${randomId}`).style.display = 'none';
          }}
        >
          &times;
        </span>
        <img className={`modal-content modal-content-${randomId}`} id="img01" />
      </div>
    </RTEPreview>
  );
}

export default RichTextEditorPreview;
